// extracted by mini-css-extract-plugin
module.exports = {"help-center-link":"HelpCenterLink_help-center-link__26EGo"};